import { render } from "./erpUrl.vue?vue&type=template&id=0e7ca728&ts=true"
import script from "./erpUrl.vue?vue&type=script&lang=ts"
export * from "./erpUrl.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__